const semanticClassNames = {
  root: 'language-menu',
  option: 'language-menu__option',
} as const;

export default semanticClassNames;
